import { getWixThumbnailsUrls } from '@wix/thumbnail-generator';
import { splitTags, get } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
import { SourceName } from '../../../constants/SourceName';
export function toItem(itemData, settings, thumbnailSizes) {
  const mimeFromMediaType = mediaType => {
    switch (mediaType) {
      case MediaType.Shape:
        return 'image/svg+xml';
      case MediaType.Video:
        return 'video/mp4';
      default:
        return 'image/jpeg';
    }
  };
  const item = {
    id: itemData.guid,
    name: itemData.title,
    mediaType: itemData.mediaType,
    mimeType: mimeFromMediaType(itemData.mediaType),
    kind: ItemKind.File,
    source: SourceName.Public,
    fileName: itemData.fileName,
    fileUrl: itemData.fileUrl,
    createdAt: null,
    tags: splitTags(itemData.tags),
    tagsEn: splitTags(itemData.tagsEn),
    systemTags: splitTags(itemData.systemTags),
    width: itemData.width,
    height: itemData.height,
    fileOutput: itemData.fileOutput || null,
    fileInput: itemData.fileInput ? itemData.fileInput : itemData.mediaType === MediaType.Video ? {
      duration: itemData.videoDuration
    } : {},
    vendor: itemData.vendor || null,
    reference: itemData.reference || null,
    creator: itemData.creator || null,
    creatorPicture: itemData.creatorPicture ? `media/${itemData.creatorPicture}` : null,
    externalId: itemData.externalId || null,
    videoThumbnailUrl: itemData.videoThumbnailUrl || get(itemData, 'fileOutput.image[0].url', null),
    previewUrl: itemData.previewUrl || null,
    hasRelatedItems: itemData.hasRelatedItems || false
  };
  if (itemData.thumbnailUrl && itemData.fileUrl) {
    const folderName = itemData.fileUrl.split('/')[0];
    item.thumbnailUrl = `${folderName}/${itemData.thumbnailUrl}`;
  }
  if (itemData.videoPreviewUrl) {
    item.videoPreviewUrls = [`${settings.videoFilesUrl}/${itemData.videoPreviewUrl}`];
  }
  if (itemData.subCategoryTitle) {
    item.subCategoryTitle = itemData.subCategoryTitle;
  }
  if (itemData.parentCategoryId) {
    item.parentCategoryId = itemData.parentCategoryId;
  }
  if (itemData.categoryId) {
    item.categoryId = itemData.categoryId;
  }
  if (itemData.hasMoreItemsInThisCategory) {
    item.hasMoreItemsInThisCategory = itemData.hasMoreItemsInThisCategory;
  }
  const itemFileOutputVideoUrl = get(itemData, 'fileOutput.video[0].url');
  if (itemFileOutputVideoUrl) {
    item.videoPreviewUrls = [`${settings.videoFilesUrl}/${itemFileOutputVideoUrl}`];
  }
  const sizes = {
    ...settings.thumbnailSizes,
    ...thumbnailSizes
  };
  const thumbnailFit = sizes.thumbnailFit;
  delete sizes.thumbnailFit;
  if (/\.png$/i.test(item.fileUrl)) {
    sizes.thumbnail = thumbnailFit;
  }
  return {
    ...item,
    ...getWixThumbnailsUrls(item, sizes, settings)
  };
}